import { Navigate } from 'react-router-dom';
import { getCurrentUser } from '../services/authentication.service';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * ProtectedRoute component that checks authentication before rendering children
 * Redirects to home page if user is not authenticated
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const user = getCurrentUser();

  if (!user) {
    return (
      <Navigate
        to='/'
        replace
      />
    );
  }

  return <>{children}</>;
}

/**
 * AdminRoute — requires authentication AND role === 'admin'.
 * Non-admin users are redirected to /app (home) rather than exposing the
 * fact that an admin section exists.
 */
export function AdminRoute({ children }: ProtectedRouteProps) {
  const user = getCurrentUser();

  if (!user) {
    return (
      <Navigate
        to='/'
        replace
      />
    );
  }

  if (user.role !== 'admin') {
    return (
      <Navigate
        to='/app'
        replace
      />
    );
  }

  return <>{children}</>;
}
